import CommunicationPanel from '@uvocore-front/communication-panel';

// eslint-disable-next-line no-unused-vars
const communicationPanel = new CommunicationPanel();

window.communicationPanel = communicationPanel;
